import { RootStore } from '@/app/store'
import { makeAutoObservable, runInAction } from 'mobx'

class ElevenLabsWidgetStore {
    isOpen = false
  constructor() {
    makeAutoObservable(this)
  }

  setOpen(loaded: boolean) {
    this.isOpen = loaded
  }
}

class ContactFormStore {
  isOpen = false
  transcript: string | null = null
  
  constructor() {
    makeAutoObservable(this)
  }

  setOpen(state: boolean) {
    window.location.hash = state ? '#escalar-a-soporte-humano' : ''
    this.isOpen = state
  }

  setTranscript(text: string | null) {
    this.transcript = text
  }
}


export class SupportStore {
    rootStore: RootStore
    isOpen: boolean
    elevenLabsWidgetStore: ElevenLabsWidgetStore
    contactFormStore: ContactFormStore


      constructor(rootStore: RootStore) {
        this.isOpen = false
        this.rootStore = rootStore
        this.elevenLabsWidgetStore = new ElevenLabsWidgetStore()
        this.contactFormStore = new ContactFormStore()
        makeAutoObservable(this)
  }

  setOpen(state: boolean) {
    this.isOpen = state
    if (state) {
      // By default, open ElevenLabs Widget when Support is opened
      this.elevenLabsWidgetStore.setOpen(true)
      this.contactFormStore.setOpen(false)
    } else {
      this.elevenLabsWidgetStore.setOpen(false)
      this.contactFormStore.setOpen(false)
    }
  }

  openElevenLabsWidget() {
    this.elevenLabsWidgetStore.setOpen(true)
    this.contactFormStore.setOpen(false)
  }
  
  openContactForm(transcript?: string) {
    const GRACE_MS = 13500;

    setTimeout(() => {
      runInAction(() => {
        this.elevenLabsWidgetStore.setOpen(false)
        this.contactFormStore.setTranscript(transcript ?? '')
        this.contactFormStore.setOpen(true)
      })
    }, GRACE_MS);

  }
}